import {SignInState} from './interface'

// Initial Setting State
export const initialState: SignInState = {
    "userData": {}
};